import { useCallback, useContext } from 'react';
import { MultiSiteContext } from '../contexts/MultiSiteContext';

/**
 * Custom React hook to get the function that returns useful multi-site values, the site, the locale and
 * the function used to build URLs following the App configuration.
 */
const useMultiSite = () => {
    const context = useContext(MultiSiteContext);
    if (!context) {
        throw new Error('useMultiSite must be used within MultiSiteProvider');
    }
    const { buildUrl: originalFn, site, locale } = context;

    const buildUrl = useCallback(
        (path: string, siteRef?: string, localeRef?: string) =>
            originalFn(
                path,
                siteRef ?? site.alias ?? site.id,
                localeRef ?? locale.alias ?? locale.id,
            ),
        [originalFn, site, locale],
    );
    return { site, locale, buildUrl };
};

export { useMultiSite };
